
document.addEventListener('DOMContentLoaded', function() {
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12 });
  document.querySelectorAll('.z-fade').forEach(el => io.observe(el));

  // FAQ
  document.querySelectorAll('.z-faq-q').forEach(btn => {
    btn.addEventListener('click', function() {
      const item = this.closest('.z-faq-item');
      const ans = item.querySelector('.z-faq-a');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.z-faq-item.open').forEach(i => {
        i.classList.remove('open');
        i.querySelector('.z-faq-a').style.maxHeight = '0';
      });
      if (!isOpen) {
        item.classList.add('open');
        ans.style.maxHeight = ans.scrollHeight + 'px';
      }
    });
  });
});
